import { createContext, useContext } from 'react';
import { ThemeColor } from '../config/colors';

type ThemeContextType = {
  color: ThemeColor;
  backgroundColor: 'white' | 'sand';
};

export const themeContext = createContext<ThemeContextType>({
  color: 'purple',
  backgroundColor: 'white',
});

export const useTheme = () => {
  const theme = useContext(themeContext);

  return theme;
};
